import { supabase } from '../auth/supabaseClient'
import type { SessionRec, SetRec } from './store'

export async function fetchRecentSessions(days = 30): Promise<SessionRec[]> {
  try {
    const { data: auth } = await supabase.auth.getSession()
    if (!auth.session) return []
    const sinceIso = new Date(Date.now() - days * 86400000).toISOString()
    const { data: sessRows, error } = await supabase
      .from('sessions')
      .select('id, started_at, ended_at, total_reps')
      .gte('started_at', sinceIso)
      .order('ended_at', { ascending: false })
    if (error || !sessRows || sessRows.length === 0) return []
    const ids = sessRows.map(r => r.id)
    const { data: setRows } = await supabase
      .from('session_sets')
      .select('session_id, idx, reps, duration_s')
      .in('session_id', ids)

    const bySess: Record<string, SetRec[]> = {}
    ;(setRows || []).forEach(row => {
      const arr = bySess[row.session_id] || (bySess[row.session_id] = [])
      arr.push({ id: `${row.session_id}-set-${row.idx}`, reps: row.reps, durationMs: (row.duration_s || 0) * 1000 })
    })
    Object.values(bySess).forEach(arr => arr.sort((a,b) => Number(a.id.split('-').pop()) - Number(b.id.split('-').pop())))

    const out: SessionRec[] = sessRows.map(r => ({
      id: r.id,
      startedAt: Date.parse(r.started_at as any),
      endedAt: r.ended_at ? Date.parse(r.ended_at as any) : undefined,
      reps: r.total_reps || 0,
      sets: bySess[r.id] || [],
      version: 1,
    }))
    return out
  } catch {
    return []
  }
}
